/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';

export default class IntercomAsCodeRoute extends Route {
  @service declare appService: AppService;

  // The React island bridge gates rendering on `metadata.react`. The actual
  // island only mounts when a route template renders `<React::TeammateAppIsland>`,
  // so the matching `.hbs` template conditionally renders it on the same flag.
  // When the flag is off we fall through to the empty outlet (zero-discoverability
  // for v1: nav surface is intentionally absent, and a non-flagged admin who
  // lands here by URL sees nothing).
  buildRouteInfoMetadata() {
    return {
      responsibleTeam: 'team-knowledge-foundations',
      react: this.appService.app?.canUseFeature('team-kf-github-sync') ?? false,
    };
  }
}
